module.exports = __webpack_public_path__ + "static/media/a-viertel-2.22462abe.jpg";